import React, { useContext } from "react";
export var ConfigContext = React.createContext({
  locale: "en",
  apiBaseUrl: "https://dev.fitplanapp.com",
  imageBaseUrl: "https://images.fitplanapp.com",
  stripeProductId: "",
  stripePublicKey: "",
  googleApiClientId: "",
  facebookAppId: "",
  fitplanApiLoginClientId: "",
  fitplanApiLoginClientSecret: "",
  fitplanClientId: "",
  fitplanClientSecret: "",
  isProduction: false
});
export var useConfig = function useConfig() {
  return useContext(ConfigContext);
};